import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VuexPersist from "vuex-persist";
Vue.use(Vuex, vuexPersist);
const vuexPersist = new VuexPersist({
  key: "cmt-settings",
  storage: window.localStorage
});
export default new Vuex.Store({

  plugins: [vuexPersist.plugin],
  
  state: {
    csrfToken: "",
    firstName: "",
    lastName: "",
    availableChannels: [],
    savedQuestions: [],
    questionFilters: [],
    surveyScope: "primary",
    clients: "external",
    core: false,
    savedOnly: false,
    activeGroup: Object
  },
  
  mutations: {
    UPDATE_AVAILABLE_CHANNELS(state, payload) {
      state.availableChannels = payload;
    },
    ADD_SAVED_QUESTION(state, payload) {
      if(state.savedQuestions.includes(payload) == false){
        state.savedQuestions.push(payload);
      }
    },
    REMOVE_SAVED_QUESTION(state, payload) {
      const index = state.savedQuestions.indexOf(payload);
      if (index > -1) {
        state.savedQuestions.splice(index, 1);
      }   
    },
    UPDATE_QUESTION_FILTERS(state, payload) {
      state.questionFilters = payload;
    },
    UPDATE_SURVEY_SCOPE(state, payload) {
      state.surveyScope = payload;
    },
    UPDATE_CLIENTS(state, payload) {
      state.clients = payload;
    },
    UPDATE_CORE(state, payload) {
      state.core = payload;
    },
    UPDATE_SAVED_ONLY(state, payload) {
      state.savedOnly = payload;
    },
    UPDATE_ACTIVE_GROUP(state, payload) {
      state.activeGroup = payload;
    },
    UPDATE_ALL(state, userData) {
       state.availableChannels =  userData.availableChannels;
       state.savedQuestions =  userData.savedQuestions;
       state.questionFilters =  userData.questionFilters;
       state.surveyScope =  userData.surveyScope;
       state.clients =  userData.clients;
       state.core =  userData.core;
       state.savedOnly =  userData.savedOnly;
       state.activeGroup =  userData.activeGroup;
    }
  },
  actions: {
    async getUserData({ commit }) {
      let token = window.csrfToken;
      console.log("getUserData:=======");
      console.log("commit:");
      console.log(commit);
      try {
        const data = await axios.get(
          "https://cmt.citizenfirst.ca/user_data/"
        );
        commit("UPDATE_STORE", data.data);
      } catch (error) {
        alert(error);
        console.log(error);
      }
    },
    async setUserData({ payload }) {
      let token = window.csrfToken;
      let dataToSave = payload;
      console.log("setUserData:=======");
      console.log("payload:");
      console.log(payload);
      try {
        const responseData = await axios.post(
          "https://cmt.citizenfirst.ca/userdata/"
        );
        console.log(responseData);
      } catch (error) {
        alert(error);
        console.log(error);
      }
    },
  },
  modules: {}
});


// store/index.js
/*
import { createStore } from "vuex";
import axios from "axios";
export default createStore({
  state: {
    users: [],
  },
  getters: {
    getUsers: (state) => state.users,
  },
  actions: {
    async fetchUsers({ commit }) {
      try {
        const data = await axios.get(
          "https://jsonplaceholder.typicode.com/users"
        );
        commit("SET_USERS", data.data);
      } catch (error) {
        alert(error);
        console.log(error);
      }
    },
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
  },
});*/